import { FC, createContext, useContext, useState, useCallback } from 'react'
import {
  QueryRequestContextProps,
  QueryState,
  WithChildren,
  initialQueryRequest,
} from '../../../../../../_metronic/helpers'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  // Erros na ordem da planilha.
  const [state, setState] = useState<QueryState>({
    ...initialQueryRequest.state,
    fixedSort: [{ field: 'linha', order: 'asc' }],
  })

  const updateState = useCallback(
    (updates: Partial<QueryState>) => setState((prev) => ({ ...prev, ...updates })),
    []
  )

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = () => useContext(QueryRequestContext)
